import React, { useState } from 'react';
import { TabList, TabPanel, TabContext } from '@mui/lab';
import { Tab, Box } from '@mui/material';
import { tabList, boxStyle } from './style';

export default function TabPage({ tabsTitle = [], pages = [], setOpen = () => {} }) {
  const [value, setValue] = useState('0');

  const handleChange = (_, newValue) => {
    setValue(newValue);

    if (newValue === '1') {
      setOpen(true);

      return;
    }

    setOpen(false);
  };

  return (
    <TabContext value={value}>
      <Box sx={boxStyle}>
        <TabList
          onChange={handleChange}
          TabIndicatorProps={{
            style: { background: 'none' },
          }}
          centered
        >
          {tabsTitle.map((title, i) => (
            <Tab key={i} label={title} value={`${i}`} style={tabList(value, i)} />
          ))}
        </TabList>
      </Box>
      {pages.map((Page, i) => {
        const id = `${i}`;
        return (
          <TabPanel key={id} value={`${i}`}>
            <Page />
          </TabPanel>
        );
      })}
    </TabContext>
  );
}
